import { useState, useRef, useEffect } from "react";

type Args = {
  toggle?: any;
};

export const useContainerSize = ({ toggle }: Args) => {
  const [containerWidth, setContainerWidth] = useState<number>(0);
  const [containerHeight, setContainerHeight] = useState<number>(0);
  const [paddingY, setPaddingY] = useState<number>(0);
  const [paddingX, setPaddingX] = useState<number>(0);
  const [gap, setGap] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (containerRef.current) {
      const containerStyles = window.getComputedStyle(containerRef.current);
      setContainerHeight(containerRef.current.clientHeight);
      setContainerWidth(containerRef.current.clientWidth);
      setPaddingX(
        parseInt(containerStyles.paddingLeft, 10) + parseInt(containerStyles.paddingRight, 10),
      );
      setPaddingY(
        parseInt(containerStyles.paddingTop, 10) + parseInt(containerStyles.paddingBottom, 10),
      );
      setGap(parseInt(containerStyles.gap, 10));
    }
  }, [containerRef?.current?.clientWidth, containerRef.current?.clientHeight, toggle]);

  return {
    containerRef,
    containerHeight,
    containerWidth,
    paddingY,
    paddingX,
    gap,
  };
};
